import React from "react";
import { cn } from "@/lib/utils";
import StatusToggle from "@/components/toggles/StatusToggle";

interface SettingCheckboxCardProps {
    name: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checked: boolean;
    disabled?: boolean;
    children: React.ReactNode;
    id?: string;
    className?: string;
    index?: number
}

export const SettingCheckboxCard: React.FC<SettingCheckboxCardProps> = ({ name, onChange, checked, disabled, children, id, className, index }) => {
    return (
        <div className={cn("gs-detail-list-item", className)}>
            <StatusToggle index={index} name={name} onChange={onChange} checked={checked} disabled={disabled} id={id} children={children} />
        </div>
    );
};
